export const AddToNewAdGroup = 'AddToNewAdGroup';
export const AddToAllAdGroups = 'AddToAllAdGroups';
export const AddToSelectedAdGroups = 'AddToSelectedAdGroups';
